












































import VueMultiselect from 'vue-multiselect'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { SelectOption } from '../../../types/interfaces'

@Component({
  components: {
    VueMultiselect
  }
})
export default class Select extends Vue {
  @Prop({ required: true }) readonly options!: SelectOption[]
  @Prop({ default: null }) readonly value!: SelectOption | null
  @Prop({ default: 'Select option' }) readonly placeholder!: string
  @Prop({ default: false }) readonly disabled!: boolean
  @Prop({ default: false }) readonly searchable!: boolean
  @Prop({ required: false, default: '' }) readonly classes!: string
  @Prop({ default: true }) readonly caret!: boolean
  @Prop({ default: true }) readonly allowEmpty!: boolean
  @Prop({ default: false }) readonly taggable!: boolean
  @Prop({ default: false }) readonly multiple!: boolean
  @Prop({ default: false }) readonly loading!: boolean
  @Prop({ default: true }) readonly closeOnSelect!: boolean
  @Prop({ default: null }) readonly groupValues!: string | null
  @Prop({ default: null }) readonly groupLabel!: string | null
  @Prop({ default: false }) readonly showLabels!: boolean
  @Prop({ default: false }) readonly groupSelect!: boolean
  @Prop({ default: 'label' }) readonly label!: string
  @Prop({ default: 'value' }) readonly trackBy!: string
  @Prop({ default: 'No elements found. Consider changing the search query.'}) readonly noResult!: string
  @Prop({ default: 'List is empty.'}) readonly noOptions!: string
  @Prop({ default: null }) readonly isOptionDisabled!: (optionValue: number) => boolean

  active = false

  get computedClasses () {
    let classes = this.classes
    if (this.active) classes += ' active'
    return classes
  }
}
